import { AccessContext } from '@/types';

export const featureAccessMap = {
  isCurrentUserAdmin: (context: AccessContext) => context.users?.administrator,
  isBMUser: (context: AccessContext) => !!context.bssUser, // check for Brivo Management user
  isIDPSupported: (context: AccessContext) =>
    featureAccessMap.isCurrentUserAdmin(context) &&
    !featureAccessMap.isBMUser(context) &&
    context.account?.accountCapabilities?.idpManagement &&
    !context.demoUser,
  isScimEnabled: (context: AccessContext) => context.scimEnabled,
  isVideoSearchAlertsEnabled: (context: AccessContext) => context.videoSearchAlertsEnabled,
  isAddUserAllowed: (context: AccessContext) => context.account.effectiveAccountPermissions?.addUsers,
  isScimManagedUser: (context: AccessContext) => context.scimManagedUser,
};
